
import { Vue, Component, Prop } from "vue-property-decorator";
import debounce from "lodash-es/debounce";

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

interface HTMLKeypressEvent extends Event {
  keyCode: number;
}

@Component
export default class FormInput extends Vue {
  @Prop({ type: String, default: undefined }) readonly id?: string;
  @Prop({ type: [String, Number], default: undefined }) readonly value?: string | number;
  @Prop({ type: String,  default: undefined }) readonly name?: string;
  @Prop({ type: String,  default: undefined }) readonly height?: string;
  @Prop({ type: String, default: undefined }) readonly placeholder?: string;
  @Prop({ type: String, default: "text" }) readonly type!: string;
  @Prop({ type: Boolean, default: false }) readonly invalid!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: "bg-inherit" }) readonly inputClass!: string;
  @Prop({ type: String, default: "" }) readonly class: string;
  @Prop({ type: Number, default: 0 }) debounceTime!: number;

  get isNumber(): boolean {
    return this.type === "number";
  }

  checkSymbol(event: HTMLKeypressEvent): void {
    if (this.isNumber && (event.keyCode < 48 || event.keyCode > 57)) {
      event.preventDefault();
    }
  }

  handleInput = debounce((event: HTMLInputEvent): void => {
    const rawValue = event.target?.value;
    const value = this.isNumber && rawValue
      ? Number(rawValue)
      : rawValue;

    this.$emit("input", value);
  }, this.debounceTime);

  get classes(): object {
    return {
      "h-9": this.height === "sm",
      "h-input": !this.height,
      "focus:border-primary": !this.invalid && !this.inputClass,
      "border-red-300 text-red-900 placeholder-red-300 focus:border-red-300": this.invalid,
      [this.class]: true,
      [this.inputClass]: true,
    };
  }
}
